
const version = '00.00'

const scripts = {ajvValidate: null, powtoonValidate: null}
const getScripts =  async () => {
  if (!scripts.ajvValidate ) {
    const [ajvValidation, {default: schema}] = await Promise.all([
      import('../../utils/ajvValidation'),
      import('./schema/00.00.schema.json'),
      import('../../utils/powtoonValidation')
    ])
    scripts.ajvValidate = ajvValidation.createValidationForSchema(schema)
    return scripts
  }
  else {return  scripts}
}

export const validate = async powtoon => {
  const validationScripts = await getScripts()
  const ajvValidationErrors = validationScripts.ajvValidate(powtoon)

  if (ajvValidationErrors === null) {
    console.log(`validation (${version}) finished without errors`)
    return null
  }

  console.log(`validation (${version}) errors found`)
  return ajvValidationErrors
}

export function updatePowtoonContent(content){
  
}
